import { render, staticRenderFns } from "./Page1Pdf2.vue?vue&type=template&id=bdff90d4&scoped=true&"
import script from "./Page1Pdf2.vue?vue&type=script&lang=js&"
export * from "./Page1Pdf2.vue?vue&type=script&lang=js&"
import style0 from "./Page1Pdf2.vue?vue&type=style&index=0&id=bdff90d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdff90d4",
  null
  
)

export default component.exports